import { format } from 'date-fns';

import { TimeString } from '..';


const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});

const currencyAbbreviationFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumSignificantDigits: 3,
    maximumSignificantDigits: 3,
    notation: 'compact',
    compactDisplay: 'short'
});

export function formatCurrency(number: number | undefined | null) {
    if (number === undefined || number === null) {
        return null;
    }

    return currencyFormatter.format(number);
}

export function formatCurrencyCents(cents: number) {
    return formatCurrency(cents / 100);
}

export function formatCurrencyAbbreviation(number: number | undefined) {
    if (number === undefined) {
        return null;
    }

    return currencyAbbreviationFormatter.format(number).toLowerCase();
}

/**
 * Function accepts a number and returns an ordinal string for that number
 *
 * Example: toOrdinal(142) -> "142nd"
 */
export function toOrdinal(number: number) {
    const lastDigits = number % 100;
    const suffix = [
        'th', 'st', 'nd', 'rd'
    ];

    return number + (suffix[(lastDigits - 20) % 10] || suffix[lastDigits] || suffix[0]);
}

export function capitalize<T extends string>(day: T) {
    return day.charAt(0).toUpperCase() + day.slice(1) as Capitalize<T>;
}

export function formatTime(time: TimeString | null | undefined) {
    if (!time) {
        return 'N/A';
    }

    const [ hours, minutes ] = time.split(':');

    const date = new Date();
    date.setHours(parseInt(hours), parseInt(minutes));

    return format(date, 'h:mmaaa');
}

export function truncateNumber(number: number, numDecimals: number) {
    const multiplier = Math.pow(10, numDecimals);
    return (Math.trunc(number * multiplier) / multiplier).toFixed(numDecimals);
}

export function getFullName(user?: { [key: string]: any, firstName?: string, lastName?: string, middleName?: string }) {
    return user?.firstName && user?.lastName ? `${user.firstName}${user.middleName ? ` ${user.middleName}` : ''} ${user.lastName}` : '--';
}
